const statusCode = (codes) => ({
  validateStatus: (status) => (Array.isArray(codes) ? codes.includes(status) : codes === status),
});

export const status200 = statusCode(200);
